import React from 'react';
import './Line.scss';

function Line() {
  return <div className="line" />;
}

export default Line;
